import styled from 'styled-components';
import { useEncoreContextType } from "../../hooks/useEncoreContextType";
import { typeStyleBody2, viola } from "../../styles";
import { ListItem } from "../ListItem";
export var PopoverNavigationItem = styled(ListItem).withConfig({
  displayName: "PopoverNavigationItem",
  componentId: "sc-1w8ibku-0"
})(["", ";"], function () {
  return useEncoreContextType(typeStyleBody2(), viola());
});
/**
* **PopoverNavigationItem** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/PopoverNavigationItem) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-popover-popovernavigationitem--default) | [Encore](https://encore.spotify.net/web/components/popover?format=figma-figma#popovernavigation) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=7907:6134) |
*
* A list item that renders links or other content in the PopoverNaviagationItem
*
* @example
* () => <PopoverNavigationItem>List item</PopoverNavigationItem>;
*
*/

export default PopoverNavigationItem;